export default __webpack_public_path__ + "static/media/block7icon1.5be0b67d.svg";